"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmail = void 0;
/**
 * The "validateEmail" method tests if a string contains an e-mail pattern
 *
 * @param strEmail
 * @returns
 */
const validateEmail = (strEmail) => {
    /**
     * Regex to match string containing the email pattern,
     * get a further explanation at https://regex101.com/
     */
    const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return !strEmail || regex.test(strEmail);
};
exports.validateEmail = validateEmail;
